<div class="mt-pagination-dot">
  @for (page of pages; track page; let i = $index) {
    <a class="mt-page" matRipple (click)="goToPage(i)" [ngClass]="activeIndex == i ? 'mt-active' : ''"></a>
  }
</div>
